import { ClaimSearchResult } from './claim-search-result';

export class SelectableClaimSearchResult extends ClaimSearchResult {
   constructor() {
       super();
   }
    public Selected = false;
}
